import { TableCell, TableRow } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';

import { useSxStyles } from './useStyles';

export interface TeamMemberPerformanceProps {}

export const TableHeader: React.FC<TeamMemberPerformanceProps> = () => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell sx={{ width: '64px', ...sxStyles.cell }} />
      <TableCell colSpan={2} align="right" sx={sxStyles.cell}>
        <TooltippedTruncatedText>
          {t<string>('balance')}
        </TooltippedTruncatedText>
      </TableCell>
    </TableRow>
  );
};
